module.exports = __webpack_public_path__ + "static/fonts/AvenirSemiBold.27bd725.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avenir/AvenirSemiBold.woff
// module id = SDfq
// module chunks = 1